var React = require('react');

function List12x12 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Property 1=list","fill":"currentColor"},[React.createElement("rect",{"id":"Rectangle 705","width":"2","height":"2","rx":".5","key":0}),React.createElement("rect",{"id":"Rectangle 707","y":"5","width":"2","height":"2","rx":".5","key":1}),React.createElement("rect",{"id":"Rectangle 706","x":"4","width":"8","height":"2","rx":".5","key":2}),React.createElement("rect",{"id":"Rectangle 708","x":"4","y":"5","width":"8","height":"2","rx":".5","key":3}),React.createElement("rect",{"id":"Rectangle 709","y":"10","width":"2","height":"2","rx":".5","key":4}),React.createElement("rect",{"id":"Rectangle 710","x":"4","y":"10","width":"8","height":"2","rx":".5","key":5})]));
}

List12x12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = List12x12;

List12x12.default = List12x12;
